var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoadingStatus),expression:"isLoadingStatus"}],staticClass:"purchase-order-status",attrs:{"data-id":_vm.purchaseOrder.id}},[_c('div',[_c('badge',{staticClass:"badge-dot"},[_c('i',{class:_vm.statusBadgeColor})]),_vm._v("\n    "+_vm._s(_vm.status_text)+"\n  ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }